import Link from 'next/link'
import {DrupalLink} from 'src/Utils';

export default function NotYetCustomer() {
    return <div className="ajb-col-4 ajb-col-8-breakpoint margin-bottom-20-sm">
        <div className="ajb-card margin-top-0 margin-bottom-0-sm darkblue-500-bg border-radius-10 z-depth-1" data-testid="advertCard">
            <p className="h6 darkblue-100-text margin-bottom-10" data-testid="notYetCustomerText">Not yet a customer?</p>
            <span className="h3 white-text margin-bottom-10 block" data-testid="lowCostDealingText">Low cost dealing from <span className="font-weight-bold">£1.50</span></span>
            <p className="h5 white-text" data-testid="advertCardChooseText">Choose from our range of SIPP, ISA and Dealing  accounts</p>
            <DrupalLink id="login-banner-not-a-customer" action={`/our-services`} className="c-btn waves-effect waves-light button-outline button button--outline-darkblue c-btn-small" data-testid="advertCardFindOutMoreText">Find out more</DrupalLink>
        </div>
    </div>
}